<template>
    <div class="flex items-center gap-2.5">
        <div class="flex-none">
            <img src="@/assets/icon/ic-time-working.svg" alt=""/>
        </div>
        <div class="flex-auto">
            <div class="text-11 text-a-black-484848 font-light">
                {{ detail.working_day }}
            </div>
            
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
    props: {
        detail: {
            type: Object,
            required: true
        }
    },
    setup: function () {
        const days = ref([])

        onMounted(() => {
            setTimeout(() => {
                days.value = [
                    { name: "จันทร์", schedule: "08:30 - 17:30" },
                    { name: "อังคาร", schedule: "08:30 - 17:30" },
                    { name: "พุธ", schedule: "08:30 - 17:30" },
                    { name: "พฤหัส", schedule: "08:30 - 17:30" },
                    { name: "ศุกร์", schedule: "08:30 - 17:30" },
                    { name: "เสาร์", schedule: "08:30 - 17:30" },
                    { name: "อาทิตย์", schedule: "08:30 - 17:30" },
                ]
            }, 100);
        })

        return {
            days
        }
    }
})
</script>


